<template>
  <div class="main-page-content">
    <div class="do-priced-container">
      <!-- 头部：红人信息 -->
      <div class="header-section do-priced-section">
        <div class="artist-info">
          <el-avatar :src="artistInfo.avatar" :size="72" shape="circle">
            <i class="el-icon-user-solid" style="font-size: 28px; color: #c0c4cc"></i>
          </el-avatar>
          <div class="artist-detail">
            <div class="artist-name-row">
              <span class="artist-name">{{ artistInfo.name }}</span>
              <!--            <span class="artist-level level-s">{{ artistInfo.org_name }}</span>-->
              <span class="artist-level level-s">{{ basic.pm.title }}</span>
            </div>
            <div class="artist-tags">
              <span class="tag">{{ artistInfo.skin_type || '' }}</span>
            </div>
            <div class="artist-stats">
              <span class="stat-item">历史提报 <b>{{ basic.pm_count || 0 }}</b> 期刊例</span>
              <span class="stat-divider">|</span>
              <span class="stat-item">当前刊例提报 <b>{{ platformList ? platformList.length : 0 }}</b> 个平台</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 平台选择 -->
      <div class="platform-section-before">
        <div class="section-label">选择平台</div>
        <div class="platform-hint">切换后自动查询对应报价</div>
      </div>
      <div class="platform-section">
        <div class="platform-list">
          <div v-for="platform in platformList" :key="`${platform.id}`" class="platform-card"
               :class="{ active: activePlatform === `${platform.id}` }"
               @click="handlePlatformSwitch(platform.code,platform.journal_id,platform.id)">
            <platform-img :code="platform.platform_code" :name="platform.platform_name" style="margin-bottom: 6px;" />
            <div class="platform-name" :title="`${platform.platform_name} - ${platform.id}`">
              {{platform.nickname}}
            </div>
            <status-plc-price :obj="platform" style="position: absolute;right: 2px;opacity: 90%;top: 2px" />
          </div>
        </div>
      </div>

      <!-- 报价信息区域 -->
      <!-- 上期报价 -->
      <div>
        <div class="price-section-before">
          <div class="price-period">上期报价信息</div>
          <div class="period-label">{{ prevPeriodLabel }}</div>
        </div>
        <div class="price-section__previous price-section do-priced-section">
          <PriceStructView v-if="prevQuote && platformType" :quote-obj="prevQuote" :platform-type="platformType" />
          <el-empty v-else description="暂无上期报价数据" />
        </div>
      </div>


      <!-- 报价信息区域 -->
      <!-- 当前报价 -->
      <div class="curr-section">
        <div class="price-section-before">
          <div class="price-period">当前报价信息</div>
          <div class="period-label">{{ currPeriodLabel }}</div>
        </div>
        <div class="price-section__previous price-section do-priced-section">
          <template v-if="currentApplyStatus === 2">
            <PriceStructView v-if="currQuote && platformType" :quote-obj="currQuote" :platform-type="platformType" />
            <el-empty v-else description="暂无当前报价数据" />
          </template>
          <template v-else>
            <AdjustPricePanel
              v-if="currQuote && platformType"
              :key="`currAdjustPricePanel_${activePlatform}`"
              ref="currAdjustPricePanel"
              :quote-info.sync="currQuote"
              :platform-type="platformType"
              :show-single-price="priceTypeMap.single"
              :show-multi-price="priceTypeMap.multi"
              :show-mixed-price="priceTypeMap.mixed"
              :title="'当前报价'"
              :edit-price="true" />
            <el-empty v-else description="暂无当前报价数据" />
          </template>
        </div>
      </div>

      <!-- 申请改价中的报价信息 -->
      <div v-if="currentApplyStatus === 2" class="changing-section">
        <div class="price-section-before">
          <div class="price-period">申请改价中的报价信息</div>
          <div class="period-label">{{ currPeriodLabel }}</div>
        </div>
        <div class="price-section__previous price-section do-priced-section">
          <PriceStructView v-if="applyQuote && platformType" :quote-obj="applyQuote" :platform-type="platformType" />
          <el-empty v-else description="暂无申请改价数据" />
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div v-if="currentApplyStatus!==2" class="footer-section">
        <div class="footer-section__inner">
          <el-button size="medium" icon="el-icon-bell" @click="handleNotifyPricing">通知定价</el-button>

          <el-button v-if="currentStatus===1" type="primary" icon="el-icon-check" size="medium"
                     @click="handleConfirmPrice">
            {{ confirmBtnText }}
          </el-button>
          <el-button v-if="currentStatus===2" type="warning" icon="el-icon-plus" size="medium"
                     @click="handleConfirmPrice">
            {{ confirmBtnText }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PriceStructView from '@/pages/plc/compoents/PriceStructView'
import AdjustPricePanel from '@/pages/plc/compoents/AdjustPricePanel'
import { platformsTheArtist, getApplyThePlcId } from '../../../api/plc'
import PlatformImg from '../../../components/PlatformImg/index.vue'
import plcMap from '@/json/plc.json'
import StatusPlcPrice from '../../../enum/plc/tag/status-price.vue'

export default {
  name: 'DoPriced',
  components: { StatusPlcPrice, PlatformImg, PriceStructView, AdjustPricePanel },
  filters: {
    formatPrice(val) {
      if (!val) return '0'
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  data() {
    return {
      condition: {
        id: null,
        artist_id: '',
        journal_id: '',
        platform_code: '',
        pm_id: ''
      },
      plcItemId: null,
      basic: {
        platforms: [],
        pm_count: 0,
        pm: {}
      },
      // 红人信息
      artistInfo: {
        name: '',
        avatar: '',
        org_name: ''
      },
      // 平台类型（如 ONLINE / OFFLINE / DL / DAILY / LIVE / OTHER）
      platformType: null,
      // 当前选中的平台编码
      activePlatform: '',
      activePlatformNm: '',
      // 平台列表
      platformList: [],
      // 上期报价数据（通过 getLastPublicationItem 获取）
      prevQuote: null,
      // 当前报价数据（next_quote / real_quote）
      currQuote: null,
      // 申请改价中的报价数据（通过 getApplyThePlcId 获取）
      applyQuote: null,
      // 上期标签
      prevPeriodLabel: '',
      // 当前期标签
      currPeriodLabel: '',
      // 加载状态
      loading: false,
      // 当前刊例项信息（用于获取上期报价参数）
      currentInfo: null,
      // 当前刊例项状态：1=未定价，2=已定价（可申请改价）
      currentStatus: null,
      currentApplyStatus: null
    }
  },

  created() {
    this.condition = this.$route.query
    //选择的平台 key(平台类型+账号刊例账号ID)
    this.activePlatform = `${this.condition.id}`

    this.init()
  },
  computed: {
    // 报价方式：品类报价（1：n）；类目报价
    priceTypeMap() {
      const customPriceMap = plcMap.customPriceMap
      return customPriceMap[this.platformType] || {
        'multi': true,
        'single': true,
        'mixed': true,
        'showLast': true
      }
    },
    // 底部确认按钮文案
    confirmBtnText() {
      if (this.currentStatus === 1) {
        return `确认【${this.activePlatformNm || ''}】终价`
      } else if (this.currentStatus === 2) {
        return `申请【${this.activePlatformNm || ''}】改价`
      }
      return `确认【${this.activePlatformNm || ''}】终价`
    }
  },
  methods: {
    init() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Promise.all([this.getBaseInfo(), this.getItemInfo()])
        .then(() => {
          setTimeout(() => {
            loading.close()
          }, 100)
        })
        .catch(error => {
          // 如果任何一个请求失败，将在这里捕获错误
          console.error('Error fetching data:', error)
        })
    },
    async getBaseInfo() {
      const basic = await platformsTheArtist(this.condition)
      this.basic = basic || {}
      // 平台列表（从 info 中获取平台信息）
      if (basic.platforms && Array.isArray(basic.platforms) && basic.platforms.length) {
        this.platformList = basic.platforms
      } else {
        this.platformList = []
      }
    },
    // 获取刊例项详情
    async getItemInfo() {
      this.loading = true
      try {
        const { info, setting } = await this.$api.getPublicationItemInfoByArtistPlatform(this.condition)
        this.plcItemId = info.id || null
        if (info) {
          // 保存当前刊例项信息，供获取上期报价使用
          this.currentInfo = info
          // 保存状态
          this.currentStatus = info.status
          this.currentApplyStatus = info.apply_status
          // 红人信息
          this.artistInfo = {
            name: info.nickname || '',
            org_name: info.org_name || '',
            skin_type: info.skin_type || '',
            avatar: info.cover_pc_url || ''
          }
          // 平台类型（从 setting 中获取）
          this.platformType = setting?.type || null
          // 设置当前选中平台
          if (info.platform_code) {
            this.activePlatform = `${info.id}`
            this.activePlatformNm = info.platform_name
          }
          // 当前报价：根据状态决定展示内容
          // status=1（未定价）：展示 next_quote（本期预估）供编辑定价
          // status=2（已定价）：展示 real_quote（终价）供申请改价
          if (info.status === 1) {
            this.currQuote = info.next_quote || null
          } else if (info.status === 2) {
            this.currQuote = info.real_quote || info.next_quote || null
          } else {
            this.currQuote = info.real_quote || info.next_quote || null
          }
          // 当前期标签
          this.currPeriodLabel = info.curr_period || ''

          // 上期报价：通过 getLastPublicationItem 接口获取
          this.getLastQuote()

          // 申请改价中的报价：当 apply_status==2 时，通过 getApplyThePlcId 接口获取
          if (info.apply_status === 2) {
            this.getApplyQuote()
          }
        }
      } catch (e) {
        console.error('获取刊例详情失败', e)
        this.$message.error('获取刊例详情失败')
      } finally {
        this.loading = false
      }
    },
    // 获取申请改价中的报价
    async getApplyQuote() {
      const info = this.currentInfo
      if (!info || !info.id) return
      try {
        const res = await getApplyThePlcId(info.id)
        // 接口返回值就是 quote-obj 的值
        this.applyQuote = res || null
      } catch (e) {
        console.error('获取申请改价数据失败', e)
        this.applyQuote = null
      }
    },
    // 获取上期报价
    async getLastQuote() {
      const info = this.currentInfo
      if (!info) return
      try {
        const { info: lastInfo } = await this.$api.getLastPublicationQuote({
          id: info.id,
          pid: info.pid,
          artist_id: info.artist_id,
          journal_id: info.journal_id,
          platform_code: info.platform_code,
          extra_platform_code: info.extra_platform_code || ''
        })
        if (lastInfo) {
          // 上期报价：优先展示 real_quote（已定价），否则展示 next_quote（预估）
          this.prevQuote = lastInfo.real_quote || lastInfo.next_quote || null
          this.prevPeriodLabel = lastInfo.curr_period || info.prev_period || ''
        } else {
          this.prevQuote = null
          this.prevPeriodLabel = info.prev_period || ''
        }
      } catch (e) {
        console.error('获取上期报价失败', e)
        this.prevQuote = null
        this.prevPeriodLabel = info?.prev_period || ''
      }
    },

    // 切换平台 platform.journal_id
    handlePlatformSwitch(code,journal_id,id) {
      this.activePlatform = `${id}`
      this.condition.id = id
      this.condition.platform_code = code
      this.condition.journal_id = journal_id
      this.init()
    },
    // 通知定价
    async handleNotifyPricing() {
      try {
        await this.$api.handleRealQuoteNotify(this.plcItemId)
        this.$message.success('已通知定价')
      } catch (e) {
        this.$message.error('通知失败')
      }
    },
    // 确认终价 / 申请改价
    async handleConfirmPrice() {
      if (this.currentStatus === 1) {
        // status=1：定价（保存终价）
        this.handleSaveRealQuote()
      } else if (this.currentStatus === 2) {
        // status=2：申请改价（保存本期预估）
        this.handleApplyEditPrice()
      } else {
        this.$message.warning('未知状态，无法操作')
      }
    },
    // 定价：保存终价
    async handleSaveRealQuote() {
      this.$confirm('确定要确认该红人的最终定价吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            if (this.currQuote && this.currentInfo) {
              await this.$api.saveRealQuote({
                id: this.currentInfo.id,
                real_quote: this.currQuote
              })
              this.$message.success('定价确认成功')
              // 刷新数据
              this.init()
            }
          } catch (e) {
            this.$message.error('定价确认失败')
          }
        })
        .catch(() => {
        })
    },
    // 申请改价：保存本期预估
    async handleApplyEditPrice() {
      this.$confirm('确定要提交改价申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            if (this.currQuote && this.currentInfo) {
              await this.$api.saveQuoteItem({
                id: this.currentInfo.id,
                next_quote: this.currQuote
              })
              this.$message.success('已提交改价申请，请等待审核')
              // 刷新数据
              this.init()
            }
          } catch (e) {
            this.$message.error('改价申请提交失败')
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="scss">
/* 主要内容区域样式 */
.main-page-content {
  position: relative;
  z-index: 1;
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px 20px 20px;
  transition: padding-top 0.3s ease;

  width: clamp(1200px, 98%, 1380px);
}

.plc_do_priced_mars-ape-layout {
  background: #FAFAFB !important;
  width: clamp(980px, 98%, 1280px);
  margin: auto;
}

.do-priced-container {
  width: clamp(880px, 98%, 1080px);
  margin: 0 auto;
  padding: 24px 20px 100px;

  .do-priced-section {
    border-radius: 20px;
    background: #ffffff;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.06), 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0);
  }

  /* ===== 头部：红人信息 ===== */
  .header-section {
    padding: 28px 32px;
  }

  .artist-info {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .artist-detail {
    flex: 1;
  }

  .artist-name-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
  }

  .artist-name {
    font-size: 22px;
    font-weight: 700;
    color: #212133;
  }

  .artist-level {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.6;

    &.level-s {
      background: linear-gradient(135deg, #ff3176, #ff6b9d);
      color: #fff;
    }
  }

  .artist-tags {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 10px;

    .tag {
      font-size: 13px;
      color: #606266;
    }

    .tag-divider {
      color: #dcdfe6;
      margin: 0 2px;
    }
  }

  .artist-stats {
    display: flex;
    align-items: center;
    gap: 12px;

    .stat-item {
      font-size: 13px;
      color: #909399;

      b {
        color: #212133;
        font-weight: 600;
      }

      &.verified {
        color: #67c23a;
        position: relative;
        padding-left: 18px;

        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 14px;
          height: 14px;
          background: #67c23a;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }

        &::after {
          content: '✓';
          position: absolute;
          left: 3px;
          top: 50%;
          transform: translateY(-50%);
          color: #fff;
          font-size: 10px;
          font-weight: bold;
        }
      }
    }

    .stat-divider {
      color: #e4e7ed;
    }
  }

  /* ===== 平台选择 ===== */
  .platform-section-before {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-top: 32px;

    .section-label {
      font-size: 15px;
      font-weight: bold;
      color: #1a1a2e;
    }

    .platform-hint {
      font-size: 12px;
      color: #8a8aa3;
    }
  }

  .platform-list {
    display: flex;
    gap: 12px;
    width: 100%;
  }

  .platform-card {
    flex: 1;
    padding: 16px 12px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.25s ease;
    border: 2px solid transparent;
    max-width: 280px!important;
    position: relative;

    &:hover {
      border-color: #ff3176;
      background: #fff5f8;
    }

    &.active {
      border: 2px solid #ff3176;
      background: linear-gradient(135deg, #fff5f8, #ffe8ef);
      box-shadow: 0 2px 8px rgba(255, 49, 118, 0.12);
    }

    .platform-name {
      font-size: 15px;
      font-weight: 600;
      color: #212133;
      position: relative;
    }

    .platform-fans {
      font-size: 18px;
      font-weight: 700;
      color: #ff3176;
    }
  }

  /* ===== 报价信息区域 ===== */
  .price-section-before {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    margin-top: 32px;

    .price-period {
      color: #4a4a68;
      font-size: 15px;
      font-weight: 650;
      position: relative;
      padding-left: 12px;
    }

    .price-period:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 4px;
      border-radius: 9999px;
      height: 16px;
      background: #4a4a68;
    }

    .period-label {
      font-size: 13px;
      color: #909399;
      margin-bottom: 16px;
    }
  }


  .curr-section {
    .price-period:after {
      background: linear-gradient(166deg, #ff3176 1%, #ff6b9d 100%) !important;
    }

    .price-period {
      color: #1A1A2E !important;
    }
  }

  .changing-section {
    .price-period:after {
      background: linear-gradient(166deg, #ff5731 1%, #ffba6b 100%) !important;
    }
  }

  .price-section {
    padding: 24px;
  }

  .overall-change {
    font-size: 13px;
    color: #606266;
    margin-bottom: 16px;
    padding: 8px 12px;
    background: #fff5f8;
    border-radius: 6px;

    .change-rate {
      color: #ff3176;
      font-weight: 700;
      font-size: 15px;
    }
  }

  .price-items {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .price-item {
    padding: 14px 16px;
    background: #fafafa;
    border-radius: 8px;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }
  }

  .price-value {
    font-size: 22px;
    font-weight: 700;
    color: #212133;
    margin-bottom: 2px;
  }

  .price-change {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 4px;

    &.up {
      color: #ff3176;
    }

    &.down {
      color: #67c23a;
    }
  }

  .price-label {
    font-size: 13px;
    font-weight: 500;
    color: #606266;
    margin-bottom: 2px;
  }

  .price-desc {
    font-size: 12px;
    color: #c0c4cc;
  }

  /* ===== 底部操作栏 ===== */
  .footer-section {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    background: #fff;
    padding: 16px 0;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
    z-index: 2000;
  }

  .footer-section__inner {
    max-width: 1100px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    gap: 12px;
  }

  .footer-section__inner .el-button {
    flex: 1;
    height: 48px;
    border-radius: 12px;
  }

  @keyframes pulse-dot {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
  }

}
</style>
